import { FilterFieldDefinition } from '../../composables/useUrlFilters';
import { UrlFilterSerializer } from '../UrlFilterSerializer';

export const RefundFilterDefinitions: FilterFieldDefinition[] = [
    {
        key: 'refundId',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'orderNumber',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'marketplaceCode',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.marketplaceOptions?.some((opt: any) => opt.code === value) ?? false;
        }
    },
    {
        key: 'refundType',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.refundTypeOptions?.some((opt: any) => opt.value === value) ?? false;
        }
    },
    {
        key: 'balanceType',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.balanceTypeOptions?.some((opt: any) => opt.value === value) ?? false;
        }
    },
    {
        key: 'description',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'reason',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'remarks',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'dateRefundOnFrom',
        type: 'date',
        defaultValue: null,
        serialize: UrlFilterSerializer.serializeDate,
        deserialize: UrlFilterSerializer.deserializeDate
    },
    {
        key: 'dateRefundOnTo',
        type: 'date',
        defaultValue: null,
        serialize: UrlFilterSerializer.serializeDate,
        deserialize: UrlFilterSerializer.deserializeDate
    }
];
